module.exports = __webpack_public_path__ + "static/media/spine_sqr_sm.6aa8eb53.jpg";